import { render, staticRenderFns } from "./NavbarV2.vue?vue&type=template&id=65d46ab8&scoped=true&lang=pug"
import script from "./NavbarV2.vue?vue&type=script&lang=js"
export * from "./NavbarV2.vue?vue&type=script&lang=js"
import style0 from "./NavbarV2.vue?vue&type=style&index=0&id=65d46ab8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d46ab8",
  null
  
)

export default component.exports